import React, { useState } from "react";

// Import all videos
import video1 from "../components/VIDEO/1.mp4";
import video2 from "../components/VIDEO/2.mp4";
import video3 from "../components/VIDEO/3.mp4";
import video4 from "../components/VIDEO/4.mp4";
import video5 from "../components/VIDEO/5.mp4";
import video6 from "../components/VIDEO/6.mp4";
import video7 from "../components/VIDEO/7.mp4";
import video8 from "../components/VIDEO/8.mp4";
import video9 from "../components/VIDEO/9.mp4";
import video10 from "../components/VIDEO/10.mp4";
import video11 from "../components/VIDEO/11.mp4";
import video12 from "../components/VIDEO/12.mp4";
import video13 from "../components/VIDEO/13.mp4";

// Import all thumbnails
import thumb1 from "../images/1.png";
import thumb2 from "../images/2.png";
import thumb3 from "../images/3.png";
import thumb4 from "../images/4.png";
import thumb5 from "../images/5.png";
import thumb6 from "../images/6.png";
import thumb7 from "../images/7.png";
import thumb8 from "../images/8.png";
import thumb9 from "../images/9.png";
import thumb10 from "../images/10.png";
import thumb11 from "../images/11.png";
import thumb12 from "../images/12.png";
import thumb13 from "../images/13.png";

const videos = [
  { thumb: thumb1, video: video1, title: "jsw_cement (1080p)" },
  {
    thumb: thumb2,
    video: video2,
    title: "google_discover (zakir_khan) (1080p)",
  },
  {
    thumb: thumb3,
    video: video3,
    title: "google_discover (bhuvan_bam)_v2 (1080p)",
  },
  { thumb: thumb4, video: video4, title: "flipkart x realme_c15 v2 (1080p)" },
  {
    thumb: thumb5,
    video: video5,
    title: "New year Resolution Hai Permanent...",
  },
  { thumb: thumb6, video: video6, title: "jsw cement (new year) (1080p)" },
  {
    thumb: thumb7,
    video: video7,
    title: "building_a_stronger_and_new_odisha (...)",
  },
  { thumb: thumb8, video: video8, title: "jsw_cement_(pongal) (1080p)" },
  {
    thumb: thumb9,
    video: video9,
    title: "jsw_cement_(the leader's_choice) (1080p)",
  },
  {
    thumb: thumb10,
    video: video10,
    title: "jsw_cement_pongal_2023 v1 (1080p)",
  },
  { thumb: thumb11, video: video11, title: "polycab_(hohm).mp4 (1080p)" },
  {
    thumb: thumb12,
    video: video12,
    title: "Celebrating_International_Labour_Day",
  },
  { thumb: thumb13, video: video13, title: "Protinex Social Experiment" },
];

const VideoGallery = () => {
  const [hovered, setHovered] = useState(null);
  const [selectedVideo, setSelectedVideo] = useState(null);

  return (
    <div className="p-6 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5">
      {videos.map((item, i) => (
        <div
          key={i}
          className="relative rounded-xl overflow-hidden shadow-lg cursor-pointer transition-transform hover:scale-105"
          onMouseEnter={() => setHovered(i)}
          onMouseLeave={() => setHovered(null)}
          onClick={() => setSelectedVideo(item.video)}
        >
          <img
            src={item.thumb}
            alt={item.title}
            className="w-full h-56 object-cover"
          />

          {hovered === i && (
            <div className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center">
              <p className="text-white text-lg font-semibold px-2 text-center">
                {item.title}
              </p>
            </div>
          )}
        </div>
      ))}

      {/* Popup Modal */}
      {selectedVideo && (
        <div className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50">
          <div className="relative w-11/12 md:w-3/4 lg:w-1/2">
            <button
              className="absolute -top-4 -right-4 bg-red-500 text-white rounded-full w-8 h-8 flex items-center justify-center text-xl"
              onClick={() => setSelectedVideo(null)}
            >
              ✕
            </button>
            <video
              src={selectedVideo}
              controls
              autoPlay
              className="rounded-lg shadow-lg w-full"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default VideoGallery;
